import { useEffect, useState } from "react";
import Header from "../components/Headers";
import ImageSlider from "../components/ImageSlider";
import About from "../components/About";
import InspirationBanner from "../components/InspirationBanner";
import PerformanceSupport from "../components/PerformanceSupport";
import Gallery from "../components/Gallery";
import StatsCard from "../components/StatsCard";
import Achievements from "../components/Achievement";
import BranchesCard from "../components/BranchesCard";
import CtaBanner from "../components/CtaBanner";
import Footer from "../components/Footer";

const LandingPage = () => {
  document.title = "OCSSC - Orange City Sport Shooting Club";
  const [visitorCount, setVisitorCount] = useState<number | null>(null);

  const API_URL =
    "https://68c5c6a4a712aaca2b6990e2.mockapi.io/api/v1/visitors/2";

  const fetchVisitorCount = async () => {
    try {
      const res = await fetch(API_URL);
      if (!res.ok) return;
      const data = await res.json();
      setVisitorCount(data.visitorCount);
    } catch (err) {
      console.error("Error fetching visitor count:", err);
    }
  };

  const fetchAndUpdateVisitor = async () => {
    try {
      const res = await fetch(API_URL);
      if (!res.ok) return;
      const data = await res.json();
      setVisitorCount(data.visitorCount);

      const newCount = (data.visitorCount || 0) + 1;
      const updateRes = await fetch(API_URL, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ visitorCount: newCount }),
      });

      if (updateRes.ok) {
        const updatedData = await updateRes.json();
        localStorage.setItem("visitedOnce", "true");
        setVisitorCount(updatedData.visitorCount);
      }
    } catch (err) {
      console.error("Error updating visitor count:", err);
    }
  };

  useEffect(() => {
    const visitedOnce = localStorage.getItem("visitedOnce");
    if (visitedOnce) {
      fetchVisitorCount();
    } else {
      fetchAndUpdateVisitor();
    }
  }, []);

  return (
    <div className="min-h-screen bg-[var(--bg-primary)] transition-colors duration-300">
      <Header />

      {/* Hero */}
      <ImageSlider />

      {/* About Club */}
      <About />

      {/* Inspiration Quote */}
      <InspirationBanner />

      {/* Performance Support */}
      <section id="performance_support">
        <PerformanceSupport />
      </section>

      {/* Gallery */}
      <section id="gallery">
        <Gallery />
      </section>

      {/* Stats Banner (full-width gradient) */}
      <section id="achievements">
        <StatsCard />
      </section>

      {/* Achievements */}
      <section>
        <Achievements />
      </section>

      {/* CTA Banner */}
      <CtaBanner />

      {/* Branches */}
      <section id="branches">
        <BranchesCard />
      </section>

      {/* Footer */}
      <Footer visitorCount={visitorCount} />
    </div>
  );
};

export default LandingPage;
